module.exports = __webpack_public_path__ + "img/levelup_icon_expense.b14b2e55.svg";